@if (editorForm()) {
  <empathy-preview-wrapper>
    <empathy-welcome-page-view [welcomeDetails]="welcomeDetails$()"></empathy-welcome-page-view>
  </empathy-preview-wrapper>
}
